import { apiGet } from './index'

const getDcc = params =>
  apiGet(`/api/area-postbar/myListPagePhone/${params.userId}`, params)

export { getDcc }



// WEBPACK FOOTER //
// ./src/api/dcc.js